import { observer } from 'mobx-react-lite';
import { type FC, Fragment } from 'react';

import type { CartCalculationOrderResponse } from '~/api/Catalog';

import { cartStore, checkoutStore, orderStore } from '~/stores';

import ExpressDelivery from '../ExpressDelivery';
import DeliveryTimeSkeleton from '../SkeletonCD/DeliveryTimeSkeleton';
import SlotDelivery from '../SlotDelivery';

interface DeliveryTimesProps {
  handleSelectDateModal: (
    index: number,
    order: CartCalculationOrderResponse,
  ) => void;
}

const DeliveryTime: FC<DeliveryTimesProps> = ({ handleSelectDateModal }) => {
  const { isLoading } = cartStore.calculationProcess;

  if (isLoading || checkoutStore.slotSelectionModalStore.isLoading) {
    return <DeliveryTimeSkeleton />;
  }

  return checkoutStore.deliveries?.map((delivery, index) => {
    const hasExpressDelivery = !delivery.slotDeliveryDetails;
    const currentItems = cartStore.selectedCartItems.filter(({ sku }) =>
      delivery?.itemsIds.includes(sku),
    );
    const isExpressDeliveryAvailable = currentItems.every(
      ({ count, sellableWarehouses }) => {
        const currentWHStock = Number(
          sellableWarehouses[`${orderStore.etaCalculation?.warehouse.code}`] ||
            0,
        );

        return count <= currentWHStock;
      },
    );

    const isExpressPossible =
      isExpressDeliveryAvailable && orderStore.isExpressAvailableNow;

    const key = delivery.slotDeliveryDetails
      ? delivery.slotDeliveryDetails?.scheduleSlotId +
        delivery.slotDeliveryDetails?.currentDate
      : 'express';

    const order = cartStore.deliveriesOrders[index];

    if (!order) {
      return <Fragment key={key} />;
    }

    if (isExpressPossible) {
      return (
        <Fragment key={key}>
          <ExpressDelivery
            delivery={delivery}
            order={order}
            expressDeliveryEnabled={hasExpressDelivery}
          />
          {!hasExpressDelivery && (
            <SlotDelivery
              delivery={delivery}
              order={order}
              expressDeliveryEnabled={hasExpressDelivery}
              handleSelectDateModal={() =>
                handleSelectDateModal?.(index, order)
              }
            />
          )}
        </Fragment>
      );
    }

    return (
      <SlotDelivery
        key={key}
        delivery={delivery}
        order={order}
        expressDeliveryEnabled={hasExpressDelivery}
        handleSelectDateModal={() => handleSelectDateModal?.(index, order)}
      />
    );
  });
};
export default observer(DeliveryTime);
